export default "__VITE_ASSET__vm9b7KMe__"